/*
{
    "__typename": "DigitallyReceivedPrescriberOrder",
    "status": "ON_HOLD",
    "authorizedMedication": {
        "__typename": "AuthorizedMedication",
        "id": "00002015204",
    },
    "prescribedMedication": {
        "__typename": "Medication",
        "id": "00002015204",
    },
    "changeRequestDetails": {
        "__typename": "PrescriberOrderChangeRequestDetails",
        "ndc": "00002015204"
    }
}
 */

import { getFragment } from '../../graphql/client/helpers/get-fragment';
import type { DigitallyReceivedPrescriberOrderInfoFragment } from '../../graphql/generated/graphql';

export const getChangeRequestedNDC = (
    drx?: DigitallyReceivedPrescriberOrderInfoFragment
): string | null => {
    if (!drx || drx.status !== 'ON_HOLD') {
        return null;
    }

    const authorized = getFragment(drx?.authorizedMedication);
    const prescribed = getFragment(drx.prescribedMedication);

    const requestedNdc = drx.changeRequestDetails?.ndc;
    const authorizedNdc = authorized.id;
    const prescribedNdc = prescribed.id;

    if (!requestedNdc) {
        return null;
    }

    return requestedNdc === authorizedNdc || requestedNdc === prescribedNdc
        ? null
        : requestedNdc;
};
